const PRESERVE_COMMA_KEYS = new Set<string>(['preference'])

export const splitComma = (key: string, v: unknown): unknown => {
  if (PRESERVE_COMMA_KEYS.has(key)) return v
  if (Array.isArray(v)) return v
  if (typeof v === 'string' && v.includes(',')) {
    return v
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
  }
  return v
}

/** Expand ?k=a,b → ?k=a&k=b for all keys EXCEPT those in PRESERVE_COMMA_KEYS */
export const expandCommaParamsInUrl = (url: string): string => {
  try {
    const u = new URL(url)

    const keysToExpand = new Set<string>()
    for (const [k, v] of u.searchParams.entries()) {
      if (PRESERVE_COMMA_KEYS.has(k)) continue
      const occurrences = u.searchParams.getAll(k)
      if (occurrences.length === 1 && v.includes(',')) keysToExpand.add(k)
    }
    if (keysToExpand.size === 0) return url

    const next = new URLSearchParams()
    for (const [k, v] of u.searchParams.entries()) {
      if (keysToExpand.has(k)) {
        v.split(',')
          .map((s) => s.trim())
          .filter(Boolean)
          .forEach((x) => next.append(k, x))
      } else {
        next.append(k, v)
      }
    }
    u.search = next.toString()
    return u.toString()
  } catch {
    return url
  }
}
